<div class="linked-search-frame">
    <div class="header-container">
        <div class="title">
            <ng-content select="[title]"></ng-content>
            <ng-template [ngIf]="titleKey">{{titleKey | translate}}</ng-template>
        </div>

    </div>

    <div class="body-container">
        <div class="content-container">
            <div class="results-container">
                <ng-content select="[results]"></ng-content>
            </div>
        </div>
    </div>
</div>